
import { AxiosError } from "axios";
import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";

import authService from "@/services/Auth";

import TemplatesLoginAdmin from "@/components/templates/login-admin/index.vue";

import {
  IFormData,
  GoogleOAuth2,
  GoogleTokenResponse,
} from "./interface/index";

export default defineComponent({
  components: { TemplatesLoginAdmin },
  setup() {
    const config = ref({
      isLoading: false,
      error: {},
    });
    const router = useRouter();

    const formData = reactive<IFormData>({
      email: "",
      password: "",
    });

    const submitLogin = async (formData: IFormData): Promise<void> => {
      config.value.isLoading = true;

      try {
        await authService.loginAdmin(formData);
        router.push("/admin/home");
      } catch (e: unknown) {
        const { response } = e as AxiosError;

        if (Object.keys(response?.data?.errors).length > 0) {
          config.value.error = response?.data?.errors;
        } else {
          alert(response?.data?.message);
        }
      }

      config.value.isLoading = false;
    };

    const getGoogleAPI = (): { accounts: GoogleOAuth2 } | undefined => {
      return (window as Window & { google?: { accounts: GoogleOAuth2 } })
        .google;
    };

    const submitGoogleLogin = (): void => {
      config.value.isLoading = true;

      try {
        const google = getGoogleAPI();
        if (google) {
          const client = google.accounts.oauth2.initTokenClient({
            client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID as string,
            scope: "openid email profile",
            callback: (response: GoogleTokenResponse) => {
              handleGoogleResponse(response);
            },
          });

          // Request an access token with account selection
          client.requestAccessToken({ prompt: "select_account" });
        } else {
          alert("Google Sign-In belum siap. Silakan coba lagi.");
          config.value.isLoading = false;
        }
      } catch (e: unknown) {
        const { response } = e as AxiosError;
        alert(
          response?.data?.message ||
            "Terjadi kesalahan saat login dengan Google"
        );
        config.value.isLoading = false;
      }
    };

    const handleGoogleResponse = async (
      response: GoogleTokenResponse
    ): Promise<void> => {
      config.value.isLoading = true;

      try {
        if (response.access_token) {
          await authService.loginAdminGoogle({
            access_token: response.access_token,
          });
          router.push("/admin/home");
        } else {
          alert("Gagal mendapatkan access token dari Google");
        }
      } catch (e: unknown) {
        const { response } = e as AxiosError;
        alert(
          response?.data?.message ||
            "Terjadi kesalahan saat login dengan Google"
        );
      }

      config.value.isLoading = false;
    };

    return {
      config,
      formData,
      submitLogin,
      submitGoogleLogin,
    };
  },
});
